import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'gestao', pathMatch: 'full' },
  { path: 'hub', redirectTo: 'gestao' },
  {
    path: 'gestao',
    loadComponent: () => import('./pages/gestao/gestao.component').then(m => m.GestaoComponent),
  },
  {
    path: 'etiquetas',
    loadComponent: () => import('./pages/etiquetas/etiquetas.component').then(m => m.EtiquetasComponent),
  },
  {
    path: 'acompanhamento',
    loadComponent: () => import('./pages/acompanhamento/acompanhamento.component').then(m => m.AcompanhamentoComponent),
  },
  {
    path: 'impressao-etiquetas',
    loadComponent: () => import('./pages/impressao-etiquetas/impressao-etiquetas.component').then(m => m.ImpressaoEtiquetasComponent),
  },
  {
    path: 'protocolo',
    loadComponent: () => import('./pages/protocolo/protocolo.component').then(m => m.ProtocoloComponent),
  },
  { path: '**', redirectTo: '' },
];
